import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="min-h-[80vh] flex items-center justify-center container-custom py-24">
      <div className="text-center max-w-lg">
        <p className="font-heading text-[120px] md:text-[180px] font-bold leading-none text-gradient-primary">
          404
        </p>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mt-4 mb-3">
          Looks like this page chased a squirrel.
        </h1>
        <p className="text-white/60 mb-8">
          The page you're looking for doesn't exist. Let's get you back home.
        </p>
        <Link to="/" data-testid="notfound-home-link" className="btn-primary">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
      </div>
    </div>
  );
}
